import React, { useEffect, useState, useRef } from "react";

const SNOOZE_KEY = "rv_a2hs_snoozed_at";
const SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

function isStandalone() {
  return (
    (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true
  );
}

function isSnoozed() {
  try {
    const at = parseInt(localStorage.getItem(SNOOZE_KEY) || "0", 10);
    return at && Date.now() - at < SNOOZE_MS;
  } catch (e) {
    return false;
  }
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

export const AddToScreenBanner = () => {
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);
  const deferredPrompt = useRef(null);

  useEffect(() => {
    if (isStandalone() || isSnoozed()) return undefined;
    if (isIOS()) {
      setIosHint(true);
      setVisible(true);
      return undefined;
    }
    const handler = (e) => {
      e.preventDefault();
      deferredPrompt.current = e;
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const snooze = () => {
    try {
      localStorage.setItem(SNOOZE_KEY, String(Date.now()));
    } catch (e) {
      // noop
    }
    setVisible(false);
  };

  const install = async () => {
    const promptEvent = deferredPrompt.current;
    if (!promptEvent) {
      snooze();
      return;
    }
    promptEvent.prompt();
    try {
      await promptEvent.userChoice;
    } catch (e) {
      // noop
    }
    deferredPrompt.current = null;
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="a2hs-banner"
      className="sm:hidden fixed left-2 right-2 rounded-2xl shadow-xl p-3.5"
      style={{
        bottom: "4.5rem",
        background: "white",
        border: "1px solid var(--rv-border)",
        zIndex: 900,
      }}
    >
      <div className="flex items-start gap-3">
        <img
          src="/images/icon-192.png"
          alt="Реверсия"
          className="w-10 h-10 rounded-xl flex-shrink-0"
          onError={(e) => { e.target.style.display = "none"; }}
        />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-text-primary)" }}>
            Добавить Реверсию на экран
          </p>
          <p data-testid={iosHint ? "a2hs-ios-hint" : "a2hs-android-text"} className="text-xs mt-0.5 leading-snug" style={{ color: "var(--rv-text-muted)", fontFamily: "IBM Plex Sans,sans-serif" }}>
            {iosHint
              ? 'Чтобы открыть как приложение: Поделиться, затем "На экран Домой".'
              : "Иконка на экране телефона — открывайте задания в один тап."}
          </p>
        </div>
      </div>
      <div className="flex gap-2 mt-2.5">
        {iosHint ? (
          <button
            data-testid="a2hs-got-it-btn"
            onClick={snooze}
            className="flex-1 py-2 rounded-lg text-sm font-semibold"
            style={{ background: "var(--rv-teal)", color: "white", border: "none", cursor: "pointer", fontFamily: "IBM Plex Sans,sans-serif" }}
          >
            Понятно
          </button>
        ) : (
          <>
            <button
              data-testid="a2hs-install-btn"
              onClick={install}
              className="flex-1 py-2 rounded-lg text-sm font-semibold"
              style={{ background: "var(--rv-teal)", color: "white", border: "none", cursor: "pointer", fontFamily: "IBM Plex Sans,sans-serif" }}
            >
              Добавить
            </button>
            <button
              data-testid="a2hs-dismiss-btn"
              onClick={snooze}
              className="flex-1 py-2 rounded-lg text-sm font-medium"
              style={{ background: "white", color: "var(--rv-text-secondary)", border: "1px solid var(--rv-border)", cursor: "pointer", fontFamily: "IBM Plex Sans,sans-serif" }}
            >
              Не сейчас
            </button>
          </>
        )}
      </div>
    </div>
  );
};
